import { db, collection, addDoc, serverTimestamp } from "./firebase";

const emailDomain = (e) => {
  if (!e || typeof e !== "string") return null;
  const at = e.lastIndexOf("@");
  return at >= 0 ? e.slice(at + 1) : null;
};

export async function audit({ action, actor, targetCollection, targetId, metadata }) {
  try {
    await addDoc(collection(db, "audit_log"), {
      action,
      actor: actor || { source: "system" },
      targetCollection: targetCollection || null,
      targetId: targetId || null,
      metadata: metadata || {},
      createdAt: serverTimestamp(),
    });
  } catch (e) {
    // Audit must never block UX.
    // eslint-disable-next-line no-console
    console.warn("audit log write failed", { action, err: e && e.message });
  }
}

export { emailDomain };
